export const RemoteGuidanceRoleTypeEnum = {
  EXPERT: '专家',
  STAFF: '现场'
}
